const routes = {
  root: '',
  kiosk: {
    checkin: 'checkin',
  },
  auth: {
    login: 'login',
    signup: 'signup',
    forgotPassword: 'forgot-password',
    forgotPasswordSubmission: 'forgot-password-submission',
    forgotPasswordUpdate: 'forgot-password-update',
    forgotPasswordReset: 'forgot_password_reset', //'forgot-password-reset',
    staffInvitation: 'staff-invitation',
  },
  home: {
    root: 'home',
  },
  members: {
    root: 'members',
    members: {
      root: 'members',
      list: '',
      member: {
        root: ':id/:tab?/:subId?',
        detail: '',
      },
      create: 'create',
    },
  },
  operations: {
    root: 'operations',
    plans: {
      root: 'plans',
      list: '',
      create: 'create',
      plan: ':id',
    },
    staff: {
      root: 'staff',
      list: '',
      create: 'create',
      staff: ':id', // ':id/:tab?',
    },
    sessions: {
      root: 'session-access',
      list: '',
    },
  },
  verification: {
    verify: 'verify',
    verifySuccess: 'verify-success',
    staffVerify: 'staff-verify',
    verificationRequired: 'verification-required',
  },
  settings: {
    root: 'settings',
    business: {
      main: '',
      root: 'business',
      appAppearance: 'app-appearance',
      sessionClassSchedule: 'session-class-schedule',
      sessionClassTypes: 'session-class-types',
      locations: {
        root: 'locations',
        list: '',
        create: 'create',
        location: ':id',
      },
      sessionSchedule: {
        root: 'session-schedule',
      },
      rooms: {
        root: 'rooms',
        list: '',
        create: 'create',
        room: ':id',
      },
    },
  },
  schedule: {
    root: 'schedule',
    schedule: 'schedule',
  },
  myprofile: {
    root: 'myprofile',
  },
  reports: {
    root: 'reports',
    newContacts: {
      root: 'new-contacts',
    },
    netRevenueReported: {
      root: 'net-income-reported',
    },
    atRiskAttendance: {
      root: 'at-risk-attendance',
    },
    basicChurn: {
      root: 'basic-churn',
    },
    newSales: {
      root: 'new-sales',
    },
    paymentFailure: {
      root: 'payment-failure',
    },
    challengeConversionDetail: {
      root: 'challenge-conversion-detail',
    },
    quicksight: {
      root: 'custom/:id',
    },
  },
  quickActions: {
    root: 'quick_actions',
    checkins: {
      root: 'schedule/schedule',
    },
    addContact: {
      root: 'members/members/create',
    },
  },
} as const;

type T = { [key: string]: string | T };

export const getRoutePath = (path = '', params: (string | number | undefined)[] = []): string => {
  const segments = path.split('.').filter((v) => !!v);
  let ref: T | null = routes;
  let fullPath = '';

  segments.forEach((segment) => {
    if (ref?.root && typeof ref.root === 'string') fullPath += `/${ref.root}`;
    if (segment !== 'root' && ref?.[segment] === undefined) throw new Error(`Invalid route path: ${path}`);

    if (typeof ref?.[segment] === 'string') {
      fullPath += `/${ref?.[segment] as string}`;
      ref = null;
    } else ref = ref?.[segment] as T;
  });

  if (ref && typeof ref !== 'string' && typeof ref.root === 'string') {
    fullPath += `/${ref.root}`;
  }

  params.forEach((param) => {
    fullPath = fullPath.replace(/:\w+\??/, (param ?? '').toString());
  });

  return fullPath;
};

export default routes;
